import React from "react";
import { AlertTriangle } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import InfoTip from "../charts/InfoTip";

// O rotulo de um numero com os seus icones logo a seguir a ultima palavra: o sinal de atencao
// (`attention`) e a ressalva (`info`). Um espaco que nao parte (U+00A0) cola o primeiro icone a ultima
// palavra, e o `whitespace-nowrap` mantem os icones juntos, por isso um rotulo que parte em linhas
// leva-os consigo. Num flex o texto partido ocupava a largura toda e o icone ia para a borda direita,
// longe da palavra. O rotulo fica num so no de texto, para se ler e procurar inteiro. Vai dentro de um
// paragrafo, que da o tamanho e a cor.
const LabelWithIcons = ({ text, attention, info }) => {
  const { translate } = useLanguage();
  return (
    <>
      {text}
      {(attention || info) && (
        <span className="whitespace-nowrap">
          {" "}
          {attention && <AlertTriangle role="img" aria-label={translate("analyticsNeedsAttention")} className="inline-block align-middle w-3.5 h-3.5" />}
          {info && (
            <span className={`inline-block align-middle${attention ? " ml-0.5" : ""}`}>
              <InfoTip text={info} label={translate("analyticsAbout", { title: text })} />
            </span>
          )}
        </span>
      )}
    </>
  );
};

export default LabelWithIcons;
